import { useEffect, useState } from "react";
import { HGHighlightText } from "../../App/App";
import SelectArrowIcon from "../../icons/select-arrow.icon";
import MyTooltip from "../../Common/my-tooltip/my-tooltip.component";
import { Dropdown, Form, Spinner } from "react-bootstrap";
import useDropdown from "../../../hooks/dropdown.hook";
import ColorPicker from "../../../common/color-picker/color-picker.component";
import ThreeDotsIcon from "../../icons/three-dots.icon";
import SwitchButton2 from "../../Theme/switch-button-2/switch-button-2.component";


const CategoryBody = ({
  category,
  hasSubCategories,
  isChild,
  isOpen,
  parentIndex,
  index,
  categories,
  setCategories,
  search,
  showDragHandle = false,
  dragHandleProps = {},
  categoryIsRemovingId,
  isHidden = false,
  toggleRow = () => {},
  onRemove = () => {},
  onDuplicate = () => {},
  onViewProducts = () => {},
  onCategoryUpdate = () => {},
  colorValidation = () => {},
  isView = false,
}) => {
  const [newName, setNewName] = useState("");
  const [isNameError, setIsNameError] = useState(false);

  const onNameUpdate = (newName) => {
    const updatedCategories = [...categories];
    updatedCategories[index].categoryName = newName;
    updatedCategories[index].isEditing = false;
    setCategories(updatedCategories);
    onCategoryUpdate(updatedCategories[index]);
  };

  useEffect(() => {
    setNewName(category.categoryName);
  }, [category?.categoryName]);

  return (
    <div
      className={`category-body ${isHidden ? "faded" : ""}`}
      onClick={() => {
        if (!isChild) {
          toggleRow();
        }
      }}
    >
      <div className="d-flex align-items-center gap-4">
        <div className="d-flex align-items-center">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: "24px",
              height: "24px",
              ...(!!search && { opacity: 0, pointerEvents: "none" }),
              ...(!showDragHandle && { pointerEvents: "none" }),
            }}
            {...dragHandleProps}
          >
            {showDragHandle && (
              <img
                alt=""
                src="/images/actioncenter/contextmenu.svg"
                className="pr-2 grab-icon"
                onClick={(e) => {}}
              />
            )}
          </div>
          <ColorDropdown
            hexColor={category.categoryHexColor}
            onColorChange={(color) => {
              const updatedCategories = [...categories];
              updatedCategories[index].categoryHexColor = color;
              setCategories(updatedCategories);
              onCategoryUpdate(updatedCategories[index]);
            }}
            colorValidation={colorValidation}
            disabled={category?.isEditing || isView}
            isHidden={isHidden}
          />
        </div>
        {category?.isEditing && !isView ? (
          <div
            className="name-input-wrapper faded-child"
            onClick={(e) => e.stopPropagation()}
          >
            <input
              id={`category-name-inp-${category.categoryId}`}
              type="text"
              className={`highlight-input-with-grey-border thin-border name-input f-14 line-height-22 f-400 f-black radius-4 ${
                isNameError ? "input-error" : ""
              }`}
              value={newName}
              onChange={(e) => {
                setIsNameError(e.target.value === "");
                setNewName(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" && e.target.value !== "")
                  onNameUpdate(newName);
              }}
              onBlur={(e) => {
                if (e.target.value !== "") onNameUpdate(newName);
              }}
            />

            {isNameError && (
              <div className="f-danger f-12 pt-1">
                {isChild ? "Sub Category" : "Category"} name can't be empty!
              </div>
            )}
          </div>
        ) : (
          <div>
            <h3 className="m-0 f-14 line-height-22 f-500 f-black d-flex align-items-center gap-6">
              <span
                dangerouslySetInnerHTML={{
                  __html: HGHighlightText(category.categoryName, search),
                }}
                className="faded-child"
              />
              {category?.isCustom && (
                <span className="custom-label faded-child">Custom</span>
              )}
              <div className="d-flex align-items-center gap-4">
                {!isView && (
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{ width: "24px", height: "24px" }}
                  >
                    <ContextMenu
                      category={category}
                      categories={categories}
                      categoryIndex={index}
                      setCategories={setCategories}
                      onViewProducts={onViewProducts}
                      categoryIsRemovingId={categoryIsRemovingId}
                      onDuplicate={onDuplicate}
                      onRemove={(category) => {
                        if (parentIndex !== undefined) {
                          onRemove({
                            ...category,
                            parentIndex,
                            childIndex: index,
                          });
                        } else {
                          onRemove({
                            ...category,
                            parentIndex: index,
                            childIndex: null,
                          });
                        }
                      }}
                    />
                  </div>
                )}
                {!isChild && (
                  <div
                    className={`d-flex align-items-center justify-content-center faded-child ${
                      isOpen ? "rotate180" : ""
                    }`}
                    style={{ width: "32px", height: "32px" }}
                  >
                    <SelectArrowIcon width="14px" />
                  </div>
                )}
              </div>
            </h3>
            {!isChild && (
              <span className="f-12 line-height-18 f-400 f-darkgrey faded-child">
                {hasSubCategories
                  ? `${category.subCategories.length} subcategor${
                      category.subCategories.length === 1 ? "y" : "ies"
                    }`
                  : "No subcategories"}
              </span>
            )}
          </div>
        )}
      </div>
      {!category?.isEditing && (
        <div
          className="d-flex align-items-center"
          style={{
            ...(!isChild && { marginRight: "20px" }),
            gap: "64px",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <MyTooltip
            renderTooltip={(props) => (
              <div className="bg-black f-white f-14 p-2 radius-4" style={{ width: '200px'}}>
                {category?.Tooltip}
              </div>
            )}
            disabled={!category?.UsedInTechSpend}
            delay={100}
            isFixed
            offset={12}
          >
            <Form.Check
              className="fixed-checkbox blue-checkbox fix-checkbox pointer-checkbox faded-child"
              type="checkbox"
              checked={category.techSpendActive}
              onChange={(e) => {
                const updatedCategories = [...categories];
                updatedCategories[index].techSpendActive = e.target.checked;
                setCategories(updatedCategories);
                onCategoryUpdate(updatedCategories[index]);
              }}
              disabled={isView || category?.UsedInTechSpend}
            />
          </MyTooltip>
          <MyTooltip
            renderTooltip={(props) => (
              <div className="bg-black f-white f-14 p-2 radius-4" style={{ width: '200px'}}>
                This category is associated with products in the storefront.
              </div>
            )}
            disabled={!category?.UsedInStoreFront}
            delay={100}
            isFixed
            offset={12}
          >
          <Form.Check
            className="fixed-checkbox blue-checkbox fix-checkbox pointer-checkbox faded-child"
            type="checkbox"
            checked={category.storefrontActive}
            onChange={(e) => {
              const updatedCategories = [...categories];
              updatedCategories[index].storefrontActive = e.target.checked;
              setCategories(updatedCategories);
              onCategoryUpdate(updatedCategories[index]);
            }}
            disabled={isView || category?.UsedInStoreFront}
          />
          </MyTooltip>
        </div>
      )}
    </div>
  );
};

export default CategoryBody;

export const ColorDropdown = ({
  hexColor,
  disabled = false,
  onColorChange = () => {},
  colorValidation,
}) => {
  const { isOpen, refBtn, refMenu, setIsOpen } = useDropdown({});
  return (
    <Dropdown
      className="transparennt-wrapper-dropdown my-dropdown"
      onClick={(e) => e.stopPropagation()}
      show={isOpen}
      onToggle={() => {
        setIsOpen(!isOpen);
      }}
      style={{
        ...(disabled && { pointerEvents: "none" }),
      }}
    >
      <Dropdown.Toggle id="dropdown-basic" ref={refBtn} className="faded-child">
        <div className="category-color-btn">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ width: "20px", height: "32px" }}
          >
            <div
              className="category-color"
              style={{ backgroundColor: hexColor }}
            />
          </div>
          <div
            className="align-items-center justify-content-center category-color-arrow"
            style={{ width: "24px", height: "24px" }}
          >
            <SelectArrowIcon fill="#9499aa" width="10px" />
          </div>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu ref={refMenu} className="menu pb-0">
        {isOpen && (
          <ColorPicker
            onSelect={(color) => {
              onColorChange(color);
              setIsOpen(false);
            }}
            colorValidation={colorValidation}
            defaultColor={hexColor}
          />
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

const ContextMenu = ({
  category,
  categories,
  categoryIndex,
  setCategories,
  categoryIsRemovingId,
  onRemove = () => {},
  onDuplicate = () => {},
  onViewProducts = () => {},
}) => {
  const { isOpen, refBtn, refMenu, setIsOpen } = useDropdown({});
  const actions = [
    {
      label: "Edit",
      className: "f-grey",
      onClick: () => {
        const updatedCategories = [...categories];
        updatedCategories[categoryIndex].isEditing = true;
        setCategories(updatedCategories);
        setIsOpen(false);
        setTimeout(() => {
          const input = document.getElementById(
            `category-name-inp-${category.categoryId}`
          );
          input.focus();
        }, 100);
      },
      show: category.isCustom,
    },
    {
      label: "View Products",
      className: "f-grey",
      onClick: () => {
        onViewProducts(category);
        setIsOpen(false);
      },
      show: true,
    },
    {
      label: "Duplicate",
      className: "f-grey",
      onClick: () => {
        onDuplicate(category.categoryId);
        setIsOpen(false);
      },
      show: true,
    },
    {
      label: "Remove",
      className: "f-red",
      loading: categoryIsRemovingId === category.categoryId,
      onClick: () => {
        onRemove(category);
      },
      show: category.isCustom,
      disabled: category.UsedInStoreFront || category.UsedInTechSpend,
    },
  ];

  const onActionClick = (action) => {
    action.onClick();
  };

  return (
    <Dropdown
      className="transparennt-wrapper-dropdown my-dropdown"
      onClick={(e) => e.stopPropagation()}
      show={isOpen}
      onToggle={() => {
        setIsOpen(!isOpen);
      }}
      alignRight
    >
      <Dropdown.Toggle id="dropdown-basic" ref={refBtn}>
        <ThreeDotsIcon width="15px" fill="#616778" />
      </Dropdown.Toggle>
      <Dropdown.Menu ref={refMenu} className="menu context-menu">
        <div className="menu-body">
          {actions.map((action, index) => {
            if (!action.show) return null;
            return (
              <div
                key={index}
                className={`menu-item bg-hover-grey d-flex align-items-center justify-content-between ${action.className}`}
                onClick={() => onActionClick(action)}
                style={{
                  ...(action.disabled && {
                    pointerEvents: "none",
                    opacity: 0.5,
                  }),
                }}
              >
                <span className="f-14 line-height-22 f-500">
                  {action.label}
                </span>
                {action.hasToggle ? (
                  <SwitchButton2 active={!category?.Visibility} />
                ) : action.loading ? (
                  <Spinner
                    animation="border"
                    size="sm"
                    className="f-14 line-height-22 f-500"
                    style={{ width: "16px", height: "16px" }}
                  />
                ) : null}
              </div>
            );
          })}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};
